var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#E84142"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.47887 12.797H4.77562C4.41787 12.797 4.24124 12.797 4.13324 12.7278C4.07634 12.6907 4.02897 12.6407 3.99497 12.5818C3.96096 12.523 3.94127 12.457 3.93749 12.3892C3.93074 12.262 4.01906 12.1062 4.19624 11.7957L8.39924 4.37467C8.57812 4.05967 8.66924 3.90217 8.78287 3.84367C8.84369 3.81275 8.91095 3.79663 8.97918 3.79663C9.04741 3.79663 9.11468 3.81275 9.17549 3.84367C9.28968 3.90217 9.38024 4.05967 9.55912 4.37467L10.4231 5.88555L10.4276 5.89342C10.6206 6.23093 10.7184 6.40305 10.7612 6.58305C10.809 6.78007 10.809 6.98566 10.7612 7.18267C10.7184 7.36436 10.6211 7.53705 10.4254 7.88017L8.21699 11.7895L8.21137 11.7991C8.01674 12.14 7.91887 12.3127 7.78162 12.4432C7.6339 12.5846 7.45456 12.6888 7.25849 12.7469C7.07906 12.797 6.87937 12.797 6.47887 12.797ZM10.7781 12.797H13.2171C13.5771 12.797 13.7582 12.797 13.8662 12.7261C13.9235 12.6888 13.9712 12.6383 14.0052 12.579C14.0392 12.5196 14.0587 12.453 14.0619 12.3847C14.0681 12.2615 13.9821 12.1124 13.8127 11.8194L13.7947 11.789L12.573 9.69536L12.5589 9.67174C12.3874 9.38092 12.3002 9.23411 12.1894 9.1773C12.129 9.14649 12.0622 9.13042 11.9945 9.13042C11.9267 9.13042 11.8599 9.14649 11.7996 9.1773C11.6871 9.2358 11.5971 9.38936 11.4182 9.69761L10.2004 11.7912L10.1964 11.7985C10.0181 12.1068 9.92868 12.2604 9.93543 12.3869C9.93917 12.4551 9.95883 12.5214 9.99282 12.5806C10.0268 12.6398 10.0742 12.6902 10.1312 12.7278C10.2369 12.797 10.4181 12.797 10.7781 12.797Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvax);
export default __webpack_public_path__ + "static/media/avax.48e46f8959971f08d6be6dc28ea3a727.svg";
export { ForwardRef as ReactComponent };